module.exports = __webpack_public_path__ + "static/assets/70377cac2fafa125883cba573ae8a2a0.svg";